import { useForm } from 'react-hook-form';
import { useEffect } from 'react';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { toastSuccess } from '../utils/toasts';
import { useCreateBusinessCashRegisterMutation, useUpdateBusinessCashRegisterMutation } from '../store';
import { BusinessCashRegisterDTO } from '../models/business';
import Switch from './atoms/Switch';
import Input from './atoms/Input';
import Button from './atoms/Button';

interface CreateCashRegisterFormProps {
  cashRegister?: BusinessCashRegisterDTO;
  businessId: string;
  onSuccess: () => void;
}

interface FormData {
  name: string;
  active: boolean;
}

const CreateCashRegisterForm = ({ cashRegister, businessId, onSuccess }: CreateCashRegisterFormProps) => {
  const [createCashRegister, { isLoading: isCreating, isSuccess: isCreateSuccess }] = useCreateBusinessCashRegisterMutation();
  const [updateCashRegister, { isLoading: isUpdating, isSuccess: isUpdateSuccess }] = useUpdateBusinessCashRegisterMutation();
  const {
    register, handleSubmit, watch, setValue,
  } = useForm<FormData>({
    defaultValues: {
      name: cashRegister?.name || '',
      active: cashRegister?.is_active || true,
    },
    resolver: yupResolver(yup.object().shape({
      name: yup.string().required('El nombre es requerido'),
      active: yup.boolean().required('El estado es requerido'),
    })),
  });

  useEffect(() => {
    if (isCreateSuccess) {
      toastSuccess('Caja creada correctamente');
      onSuccess();
    }
    if (isUpdateSuccess) {
      toastSuccess('Caja actualizada correctamente');
      onSuccess();
    }
  }, [isCreateSuccess, isUpdateSuccess, onSuccess]);

  const onSubmit = async (data: FormData) => {
    if (cashRegister) {
      await updateCashRegister({
        businessId: businessId || '',
        dto: {
          id: cashRegister.id,
          name: data.name,
          is_active: data.active,
        },
      });
    } else {
      await createCashRegister({
        businessId: businessId || '',
        dto: {
          name: data.name,
          is_active: data.active,
        },
      });
    }
  };
  return (
    <div>
      <form className='flex flex-col gap-4 mt-4' onSubmit={handleSubmit(onSubmit)}>
        <Switch label='Caja activa'
          checked={watch('active')}
          onChange={() => setValue('active', !watch('active'))}
        />
        <Input
          id="name"
          label="Nombre de la caja *"
          labelAbove
          {...register('name')}
        />
        <div className='flex flex-row gap-4'>
          <Button variant='secondary' onClick={() => { onSuccess(); }}>Cancelar</Button>
          <Button type='submit' loading={isCreating || isUpdating}>Guardar</Button>
        </div>
      </form>
    </div>
  );
};

export default CreateCashRegisterForm;
